var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"className":"inner-component-container"}},[_vm._t("header"),_c('hr'),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }